import { render, staticRenderFns } from "./EmptyDataNotify.vue?vue&type=template&id=4a6f4804&scoped=true"
import script from "./EmptyDataNotify.vue?vue&type=script&lang=ts"
export * from "./EmptyDataNotify.vue?vue&type=script&lang=ts"
import style0 from "./EmptyDataNotify.vue?vue&type=style&index=0&id=4a6f4804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f4804",
  null
  
)

export default component.exports